<template>
  <div
    class="card"
  >
    <div class="text-muted">
      reported {{ new Date(reported.created).toLocaleString() }}
    </div>
    <p class="reason">
      {{ reported.reason || 'No reason given' }}
    </p>
    <div class="btn-group">
      <router-link
        :to="{name: 'profile', params: {id: reported.reporter}}"
        target="_blank"
        class="btn btn-sm btn-primary"
      >
        View reporter
      </router-link>
      <router-link
        :to="{name: 'post_detail', params: {id: reported.post}}"
        target="_blank"
        class="btn btn-sm btn-primary"
      >
        View post
      </router-link>
      <!-- <router-link
        v-if="reported.comment"
        :to="{name: 'comment_detail', params: {id: reported.comment }}"
        target="_blank"
      >
        View comment
      </router-link> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportedItem',
  props: {
    reported: { type: Object, required: true },
    type: { type: String, default: 'post' },
  },
};
</script>

<style>
  .card {
    margin: 0 10px 10px 0;
  }
  .card .text-muted {
    font-size: .9em;
  }
  .buttons {
    text-align: right;
  }
</style>
